import { createContext, useContext, useState, useEffect } from 'react'
import api from '../services/api'

const AuthContext = createContext()

const ROTAS_POR_MODULO = [
  ['home', '/home'], ['crm', '/crm'],
  ['propostas', '/propostas'], ['apolices', '/apolices'], ['renovacoes', '/renovacoes'],
  ['sinistros', '/sinistros'], ['assistencias', '/assistencias'],
  ['fluxo_caixa', '/fluxo-caixa'], ['comissoes', '/comissoes'], ['parcelas_atraso', '/parcelas-atraso'],
  ['indicacoes', '/relatorios/indicacoes'], ['clientes', '/clientes'],
  ['cad_seguradoras', '/cadastro?tab=seguradoras'], ['cad_ramos', '/cadastro?tab=ramos'],
  ['cad_coberturas', '/cadastro?tab=coberturas'], ['cad_comissao', '/cadastro?tab=comissao'],
  ['cad_financeiro', '/cadastro?tab=financeiro'], ['cad_emails', '/cadastro?tab=emails'],
]

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      api.get('/auth/me')
        .then(r => setUsuario(r.data))
        .catch(() => localStorage.removeItem('token'))
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  const login = async (email, senha) => {
    const { data } = await api.post('/auth/login', { email, senha })
    localStorage.setItem('token', data.token)
    setUsuario(data.usuario)
    return data
  }

  const logout = () => {
    localStorage.removeItem('token')
    setUsuario(null)
  }

  const refreshUsuario = async () => {
    const { data } = await api.get('/auth/me')
    setUsuario(data)
    return data
  }

  // Admin e gerente (admin nível 2) veem as telas "só admin" (Dashboard, Usuários, Log...).
  const ehGestor = usuario?.perfil === 'admin' || usuario?.perfil === 'gerente'

  // Admin sempre tem acesso a tudo; gerente a tudo menos o Fluxo de Caixa. Demais:
  // modulos_permitidos == null (padrão) também = acesso total — a restrição por módulo é opt-in,
  // escolhida pelo admin em Cadastro > Usuários (uma chave por tela, ver auth.MODULOS no backend).
  const temAcesso = (chave) => {
    if (!usuario) return false
    if (usuario.perfil === 'admin') return true
    if (usuario.perfil === 'gerente') return chave !== 'fluxo_caixa'
    const modulos = usuario.modulos_permitidos
    return modulos == null || modulos.includes(chave)
  }

  // Primeira tela liberada, na ordem do menu — pra onde mandar quem abre uma tela sem acesso
  // (inclusive a Home logo depois do login, se ela estiver bloqueada pro usuário).
  const rotaInicial = () => ROTAS_POR_MODULO.find(([chave]) => temAcesso(chave))?.[1] || '/sem-acesso'

  return (
    <AuthContext.Provider value={{ usuario, login, logout, loading, refreshUsuario, temAcesso, ehGestor, rotaInicial }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext)
